__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['travel-header'].baseUrl;
import ModuleContainer from './components/TravelHeader';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      'react-intl': '^6.7.0',
      '@americanexpress/data-manager-utils': '^0.4.3'
    }
  });
}